// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useApp } from '../../context/AppContext';

// const Header = () => {
//     const { settings } = useApp();
//     const [searchQuery, setSearchQuery] = useState('');
//     const navigate = useNavigate();

//     const handleSearch = (e) => {
//         e.preventDefault();
//         if (searchQuery.trim()) {
//             navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
//             setSearchQuery('');
//         }
//     };

//     return (
//         <>
//             <div id="topbar" style={{ background: 'var(--navy)', color: '#ccc', fontSize: '12px', padding: '5px 0' }}>
//                 <div className="inner" style={{ maxWidth: '1280px', margin: 'auto', padding: '0 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                     <span>{new Date().toLocaleDateString('en-IN', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</span>
//                     <div>
//                         {/* <a href="#" style={{ color: '#aac', marginLeft: '14px' }}>हिन्दी</a>
//                         <a href="#" style={{ color: '#aac', marginLeft: '14px' }}>ਪੰਜਾਬੀ</a>
//                         <a href="#" style={{ color: '#aac', marginLeft: '14px' }}>मराठी</a> */}
//                         <a href="/admin" style={{ color: 'var(--gold)', marginLeft: '14px', fontWeight: '700' }}>⚙ Admin</a>
//                     </div>
//                 </div>
//             </div>

//             <header style={{ background: '#fff', borderBottom: '3px solid var(--red)' }}>
//                 <div className="inner" style={{ maxWidth: '1280px', margin: 'auto', padding: '12px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '20px' }}>
//                     <a href="/" className="logo" style={{ display: 'flex', alignItems: 'center', gap: '12px', flexShrink: 0 }}>
//                         <div style={{ width: '46px', height: '46px', background: 'var(--red)', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontFamily: 'var(--ff-label)', fontSize: '26px' }}>B</div>
//                         <div className="logo-text" style={{ lineHeight: 1 }}>
//                             <div style={{ fontFamily: 'var(--ff-label)', fontSize: '32px', color: 'var(--navy)', letterSpacing: '1px' }}>{settings.siteName || 'BharatNews'}</div>
//                             <div style={{ fontSize: '10px', color: 'var(--gray)', letterSpacing: '2px', textTransform: 'uppercase' }}>{settings.slogan || 'सत्य · समाचार · भारत'}</div>
//                         </div>
//                     </a>
//                     <div className="header-actions" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
//                         <form onSubmit={handleSearch} style={{ display: 'flex', alignItems: 'center', border: '1.5px solid var(--lgray)', borderRadius: '3px', overflow: 'hidden' }}>
//                             <input
//                                 type="text"
//                                 placeholder="Search news…"
//                                 value={searchQuery}
//                                 onChange={(e) => setSearchQuery(e.target.value)}
//                                 style={{ border: 'none', padding: '7px 12px', fontSize: '13px', width: '200px', outline: 'none', fontFamily: 'var(--ff-body)' }}
//                             />
//                             <button type="submit" style={{ background: 'var(--red)', color: '#fff', border: 'none', padding: '8px 12px', cursor: 'pointer', fontSize: '15px' }}>🔍</button>
//                         </form>
//                         {/* <a href="/live-tv" className="btn btn-red" style={{ fontSize: '12px' }}>▶ LIVE TV</a> */}
//                     </div>
//                 </div>
//             </header>
//         </>
//     );
// };

// export default Header;
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useApp } from '../../context/AppContext';

const Header = () => {
    const { settings } = useApp(); // ✅ settings already contains siteName, slogan, etc.
    const [searchQuery, setSearchQuery] = useState('');
    const navigate = useNavigate();

    const handleSearch = (e) => {
        e.preventDefault();
        if (searchQuery.trim()) {
            navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
            setSearchQuery('');
        }
    };

    return (
        <>
            <div id="topbar" style={{ background: 'var(--navy)', color: '#ccc', fontSize: '12px', padding: '5px 0' }}>
                <div className="inner" style={{ maxWidth: '1280px', margin: 'auto', padding: '0 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>{new Date().toLocaleDateString('en-IN', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</span>
                    <div>
                        <Link to="#" style={{ color: '#aac', marginLeft: '14px' }}>हिन्दी</Link>
                        <Link to="#" style={{ color: '#aac', marginLeft: '14px' }}>ਪੰਜਾਬੀ</Link>
                        <Link to="#" style={{ color: '#aac', marginLeft: '14px' }}>मराठी</Link>
                        <Link to="/admin" style={{ color: 'var(--gold)', marginLeft: '14px', fontWeight: '700' }}>⚙ Admin</Link>
                    </div>
                </div>
            </div>

            <header style={{ background: '#fff', borderBottom: '3px solid var(--red)' }}>
                <div className="inner" style={{ maxWidth: '1280px', margin: 'auto', padding: '12px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '20px' }}>

                    {/* ✅ Logo + Name Side by Side with Dynamic Tagline */}
                    <Link to="/" className="logo" style={{ display: 'flex', alignItems: 'center', gap: '12px', flexShrink: 0, textDecoration: 'none' }}>
                        <img
                            src="/logo.png"
                            alt={settings.siteName || "Wistar News"}
                            style={{ height: '60px', width: 'auto', objectFit: 'contain' }}
                            onError={(e) => e.target.style.display = 'none'}
                        />
                        <div style={{ lineHeight: 1 }}>
                            <div style={{ fontFamily: 'var(--ff-label)', fontSize: '28px', color: 'var(--navy)', letterSpacing: '1px' }}>
                                {settings.siteName || "Wistar"}<span style={{ color: 'var(--red)' }}>News</span>
                            </div>
                            {/* ✅ Dynamic Tagline - pulls from database */}
                            <div style={{ fontSize: '10px', color: 'var(--gray)', letterSpacing: '2px', textTransform: 'uppercase' }}>
                                {settings.slogan || "News That Matters"}
                            </div>
                        </div>
                    </Link>

                    <div className="header-actions" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <form onSubmit={handleSearch} style={{ display: 'flex', alignItems: 'center', border: '1.5px solid var(--lgray)', borderRadius: '3px', overflow: 'hidden' }}>
                            <input
                                type="text"
                                placeholder="Search news…"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                style={{ border: 'none', padding: '7px 12px', fontSize: '13px', width: '200px', outline: 'none', fontFamily: 'var(--ff-body)' }}
                            />
                            <button type="submit" style={{ background: 'var(--red)', color: '#fff', border: 'none', padding: '8px 12px', cursor: 'pointer', fontSize: '15px' }}>🔍</button>
                        </form>
                        <Link to="/live-tv" className="btn btn-red" style={{ fontSize: '12px' }}>▶ LIVE TV</Link>
                    </div>
                </div>
            </header>
        </>
    );
};

export default Header;